import useMedia from './useMedia';

const useMediaById = (id: string) => {
  const { media } = useMedia();
  return media[id] || {};
};

export default useMediaById;
